export enum SettingsAction {
  LIST = 'list',
  EDIT = 'edit',
}
